import type {ButtonHTMLAttributes, ReactNode} from 'react';

import {cn} from '../../../helpers/cn';
import {Badge} from '../../../ui/badge/Badge';

export type BottomTabBarItemProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  selected?: boolean;
  icon?: ReactNode;
  badge?: string;
};

export function BottomTabBarItem({
  label,
  selected = false,
  icon,
  badge,
  className,
  type = 'button',
  ...props
}: BottomTabBarItemProps) {
  return (
    <button
      type={type}
      className={cn(
        'relative flex h-full min-w-0 flex-1 touch-manipulation flex-col items-center justify-center gap-1 border-0 bg-transparent px-1 py-1.5 transition-colors duration-200 active:opacity-80',
        className
      )}
      aria-current={selected ? 'page' : undefined}
      {...props}
    >
      <span
        aria-hidden
        className={cn(
          'pointer-events-none absolute inset-x-4 top-0 h-[3px] rounded-b-full bg-[var(--color-brand)] transition-opacity duration-200',
          selected ? 'opacity-100' : 'opacity-0'
        )}
      />
      {icon ? (
        <span
          className={cn(
            'relative inline-flex text-[22px] leading-none transition-colors duration-200 [&>i]:text-inherit',
            selected ? 'text-brand' : 'text-gray-08'
          )}
        >
          {icon}
          {badge ? (
            <Badge
              variant="count"
              count={badge}
              size="sm"
              color="primary"
              className="absolute -top-2 end-0 -translate-x-1/2"
            />
          ) : null}
        </span>
      ) : null}
      <span
        className={cn(
          'max-w-full truncate transition-colors duration-200 text-body-xs',
          selected ? 'text-brand' : 'text-gray-08'
        )}
      >
        {label}
      </span>
    </button>
  );
}
